import React from 'react';
import VoiceJourneyLoader from './VoiceJourney.styles';
import { Box, Typography } from '@mui/material';
import VoiceJourneyFooter from './Sections/VoiceJourneyFooter';
import { PAGE_HEADING_ID } from '../utils/pageHeading.utils';

const VoiceJourney = ({ customDetails }) => {
	const statusMessage = 'Finvu AA is calling you, please wait...';

	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				minHeight: '100vh',
				backgroundColor: '#f8f9fa',
			}}
		>
			<Box
				role="status"
				aria-live="polite"
				aria-busy="true"
				sx={{
					flex: 1,
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					justifyContent: 'center',
					gap: '2rem',
					padding: '2rem',
				}}
			>
				<VoiceJourneyLoader aria-hidden="true" />
				<Typography
					id={PAGE_HEADING_ID}
					component="h1"
					sx={{
						color: '#514b82',
						fontWeight: 600,
						fontSize: '16px',
						textAlign: 'center',
						fontFamily: customDetails?.fontFamily,
					}}
				>
					{statusMessage}
				</Typography>
			</Box>
			<VoiceJourneyFooter customDetails={customDetails} />
		</Box>
	);
};

export default VoiceJourney;
